export default {
	api: 'https://portal-api.chatbotex.com',
	google_analytics: 'UA-85433452-6',
	callback_url: {
		payment: {
			white_label: 'https://portal.chatbotex.com/callback/payment?product_slug=white_label',
			email_plus: 'https://portal.chatbotex.com/callback/payment?product_slug=email_plus'
		}
	}
};



// WEBPACK FOOTER //
// ./src/config/environment/testing.js